import { render, staticRenderFns } from "./DataTableItem.vue?vue&type=template&id=67d4daf4"
import script from "./DataTableItem.vue?vue&type=script&lang=js"
export * from "./DataTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports